import NextLink from 'next/link'
import { ReactNode } from 'react'

export interface NextLinkWrapperProps {
  to: string
  children: ReactNode
  className: string
}
export type ILinkComponent = ({
  to,
  children,
  className,
}: {
  to: string
  children: ReactNode
  className?: string
}) => JSX.Element

const NextLinkWrapper: ILinkComponent = ({ to, children, className }) => (
  <NextLink href={to} passHref legacyBehavior prefetch={false}>
    <a className={className}>{children}</a>
  </NextLink>
)

export default NextLinkWrapper
